import { Component, DestroyRef, inject } from '@angular/core';
import { TaskItemComponent } from '../task-item';
import {
  TasksDetailFacadeService,
  TasksFacadeService,
} from '@data-access/tasks/facade';
import {
  TASK_DETAIL_FACADE_SERVICE,
  TASK_FACADE_SERVICE,
} from '@data-access/tasks/store/token';
import {
  ChipSize,
  WcgButtonComponent,
  WcgChipModule,
  WcgChipType,
} from '@wcg/frontend-framework';
import { ActivatedRoute, Router } from '@angular/router';
import { NON_MESSAGE_TASKS, TaskInstance } from '@data-access/tasks';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { HandleSideBarService } from '@data-access/shared/services';
import { TaskDetailComponent } from '../task-detail/task-detail.component';
import { SubmissionDetailFacadeService } from '@data-access/submissions';
import { ERMDateTimePipe } from '@shared/pipes/erm-date.pipe';
import { AssigneeComponent } from '@submissions/next/ui-components/assignee';
import { GoBackToListComponent } from '@submissions/next/ui-components/gobacktolist';

@Component({
  imports: [
    TaskItemComponent,
    WcgButtonComponent,
    MatIconModule,
    MatIcon,
    AssigneeComponent,
    GoBackToListComponent,
    WcgChipModule,
  ],
  providers: [
    {
      provide: TASK_FACADE_SERVICE,
      useExisting: TasksFacadeService,
    },
    {
      provide: TASK_DETAIL_FACADE_SERVICE,
      useClass: TasksDetailFacadeService,
    },
    SubmissionDetailFacadeService,
    ERMDateTimePipe,
  ],
  selector: 'wcg-task-list',
  styleUrl: './task-list.component.scss',
  templateUrl: './task-list.component.html',
})
export class TaskListComponent {
  private readonly _tasksFacadeService = inject(TasksFacadeService);
  private readonly _tasksDetailFacadeService = inject(TasksDetailFacadeService);
  private readonly _router = inject(Router);
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _handleSiderBarService = inject(HandleSideBarService);
  private readonly _submissionDetailFacadeService = inject(
    SubmissionDetailFacadeService,
  );
  private readonly _destroyRef = inject(DestroyRef);

  // Signals start
  $tasks = this._tasksFacadeService.$tasks;
  $isLoading = this._tasksFacadeService.$isLoading;
  $currentStage = this._submissionDetailFacadeService.$currentStage;
  $submissionId = this._submissionDetailFacadeService.$submissionId;
  $filtered = this._tasksFacadeService.$filtered;
  $submission = this._submissionDetailFacadeService.$submission;

  // Signals end

  noMessagesTasks = NON_MESSAGE_TASKS;

  filteredChipType = WcgChipType.CRITICAL;
  filteredChipSize = ChipSize.SLIM;
  uploadTaskDocument(_: TaskInstance | null) {
    this._router.navigate([`./upload-documents`], {
      relativeTo: this._activatedRoute,
    });
  }

  viewTaskDetail(event: TaskInstance | null) {
    if (event && this.$submissionId()) {
      this._tasksDetailFacadeService.loadTaskDetail(
        this.$submissionId()!,
        event.id,
        this.$filtered(),
      );
      this._handleSiderBarService.setSideBarComponent(TaskDetailComponent);
    }
  }

  goBackToAllTaskList() {
    this._tasksFacadeService.loadTaskList(
      this.$submissionId()!,
      this.$submission()?.current_stage || '',
    );
  }
}
